/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FreeTextbooksTopicSubtopicTree_subtopic = {
    readonly id: string;
    readonly title: string;
    readonly hasExercise: boolean;
    readonly hasLessons: boolean;
    readonly hasInvestigations: boolean;
    readonly hasWorksheet: boolean;
};
export type FreeTextbooksTopicSubtopicTree_subtopic$data = FreeTextbooksTopicSubtopicTree_subtopic;
export type FreeTextbooksTopicSubtopicTree_subtopic$key = {
    readonly " $data"?: FreeTextbooksTopicSubtopicTree_subtopic$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FreeTextbooksTopicSubtopicTree_subtopic">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "mask": false
  },
  "name": "FreeTextbooksTopicSubtopicTree_subtopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExercise",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLessons",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvestigations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWorksheet",
      "storageKey": null
    }
  ],
  "type": "FreeTextbookSubtopic",
  "abstractKey": null
};
(node as any).hash = '39ffc1a8cbdb014b7c7e5560727c2727';
export default node;
